import React from 'react';

import BirreteApps from 'crehana-icons/outline/BirreteApps';
import ChatPremium from 'crehana-icons/outline/ChatPremium';
import Refresh from 'crehana-icons/outline/Refresh';

const PAYGBenefits: React.FC<{ className?: string }> = ({ className }) => (
  <ul className={className}>
    <li className="mb-16">
      <p className="flex items-cneter">
        <BirreteApps
          size={24}
          ignoreColor
          className="fill-current text-yellow-main"
        />
        <span className="ml-12 font-body3">Clases con acceso ilimitado</span>
      </p>
    </li>
    <li className="mb-16">
      <p className="flex items-cneter">
        <ChatPremium
          size={24}
          ignoreColor
          className="fill-current text-yellow-main"
        />
        <span className="ml-12 font-body3">
          Certifícate al terminar tus cursos
        </span>
      </p>
    </li>
    <li className="mb-16">
      <p className="flex items-cneter">
        <Refresh
          size={24}
          ignoreColor
          className="fill-current text-yellow-main"
        />
        <span className="ml-12 font-body3">
          Crea un proyecto para tu portafolio
        </span>
      </p>
    </li>
  </ul>
);

export default PAYGBenefits;
